import equal from 'fast-deep-equal';
import { create } from 'zustand';

import { pick } from '@/utils'; // Ensure this is correctly implemented

import { GetUser } from '../api';

type User = NonNullable<GetUser['return']>;

type UseUserFormStore = {
  initialValues: User | null;
  setInitialValues: (values: User) => void;
  resetInitialValues: () => void;
};

const useUserFormStore = create<UseUserFormStore>((set) => ({
  initialValues: null,
  setInitialValues: (values) => set({ initialValues: values }),
  resetInitialValues: () => set({ initialValues: null }),
}));

export const isUserFormValuesChanged = (values: User) => {
  const initialValues = useUserFormStore.getState().initialValues;
  if (!initialValues) return false; // No changes if no initial values

  return !equal(
    pick(initialValues, Object.keys(values) as (keyof User)[]),
    values,
  );
};

export const setLicences = (values: User['licences']) => {
  const initialValues = useUserFormStore.getState().initialValues;
  if (!initialValues) return;

  const updatedInitialValues = {
    ...initialValues,
    licences: values,
  };

  useUserFormStore.setState({ initialValues: updatedInitialValues });
};

export const setUserFormInitialValues = (values: User) =>
  useUserFormStore.getState().setInitialValues(values);

export const resetUserFormInitialValues = () =>
  useUserFormStore.getState().resetInitialValues();
